import { a as m, Y as h } from "./register-Ba9sFUKZ.js";
import { f } from "./query-assigned-elements-CMnZBBH0.js";
import { h as d } from "./lifecycle-decorators-C04d1yHY.js";
var c = Object.defineProperty, u = Object.getOwnPropertyDescriptor, a = (t) => {
  throw TypeError(t);
}, s = (t, e, r, n) => {
  for (var o = n > 1 ? void 0 : n ? u(e, r) : e, l = t.length - 1, i; l >= 0; l--)
    (i = t[l]) && (o = (n ? i(e, r, o) : i(o)) || o);
  return n && o && c(e, r, o), o;
}, p = (t, e, r) => e.has(t) || a("Cannot " + r), E = (t, e, r) => (p(t, e, "read from private field"), r ? r.call(t) : e.get(t)), y = (t, e, r) => e.has(t) ? a("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, r), g = (t, e, r, n) => (p(t, e, "write to private field"), e.set(t, r), r);
function v(t) {
  var e;
  let r = class extends t {
    constructor() {
      super(...arguments), y(this, e);
    }
    get fieldElement() {
      return E(this, e);
    }
    set fieldElement(n) {
      g(this, e, n), this.postSetFormControlElement();
    }
    get currentInputType() {
      if (this.fieldElement)
        return this.fieldElement.type;
    }
    postSetFormControlElement() {
    }
    postFormControlSlotchange() {
    }
    handleFormControlSlotchange() {
      this.fieldElement = this.fieldElements[0], this.postFormControlSlotchange();
    }
    setInputType() {
      this.fieldElement instanceof HTMLInputElement ? this._inputType = this.fieldElement.type : this._inputType = this.fieldElement.localName;
    }
    renderFormControlTemplate() {
      return h`<slot
        @slotchange=${this.handleFormControlSlotchange}></slot>`;
    }
  };
  return e = /* @__PURE__ */ new WeakMap(), s([
    f({ flatten: !0 })
  ], r.prototype, "fieldElements", 2), s([
    m()
  ], r.prototype, "_inputType", 2), r = s([
    d("FormControl")
  ], r), r;
}
export {
  v as w
};
